<i18n>
  {
    "fr": {
      "title": "Conformité des projets",
      "text": "Suivez la progression des projets pour identifier les priorités et assurer une gestion optimale des tâches en cours.",
      "link": "Consulter les tâches à faire"
    },
    "en": {
      "title": "Projects compliance",
      "text": "Monitor the progress of projects to identify priorities and ensure optimal management of current tasks.",
      "link": "View tasks to do"
    }
  }
</i18n>

<template>
  <compliance-chart
    :title="$t('title')"
    :text="$t('text')"
    :linkText="$t('link')"
    :link="tasksLink"
    :done-count="data.doneCount"
    :in-progress-count="data.inProgressCount"
    :todo-count="data.todoCount"
    :not-applicable-count="data.notApplicableCount"
  />
</template>

<script>
import ComplianceChart from './compliance-chart'

export default {
  components: { ComplianceChart },
  props: {
    data: { type: Object, required: true }
  },
  computed: {
    tasksLink() {
      return { text: this.$t('link'), name: this.$consts.urls.URL_PENDING_TASKS, query: { tab: 'projects' } }
    }
  }
}
</script>

<fragments>
fragment projectComplianceChart on IndicatorsProgressStatsGraphType {
  doneCount
  inProgressCount
  notApplicableCount
  todoCount
}
</fragments>
